(() => {
  'use strict';
  const roots = new WeakMap();
  let busy = false;
  // Expose the app's own validation to assistive technology without changing its
  // field names, upload validation, personalization properties or submission.
  document.querySelectorAll('[data-alhc-product]').forEach(product => {
    let previousErrors = '';
    const enhanceErrors = () => {
      const errors = [];
      let firstInvalid;
      product.querySelectorAll('.gpo-app .gpo-element').forEach(element => {
        const field = element.querySelector('input:not([type=hidden]),textarea,select');
        const messages = element.querySelector('.messages');
        if (!field || !messages) return;
        if (field.hasAttribute('presence')) field.setAttribute('aria-required', 'true');
        const text = element.classList.contains('has-error') ? messages.textContent.trim() : '';
        if (!messages.id) messages.id = (field.id || element.dataset.elementId) + '-alhc-error';
        messages.setAttribute('aria-live', 'polite');
        const described = new Set((field.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean));
        if (text) {
          field.setAttribute('aria-invalid', 'true'); field.dataset.alhcInvalid = 'true';
          described.add(messages.id); errors.push(text); firstInvalid ||= field;
        } else if (field.dataset.alhcInvalid) {
          field.removeAttribute('aria-invalid'); delete field.dataset.alhcInvalid; described.delete(messages.id);
        }
        if (described.size) field.setAttribute('aria-describedby', [...described].join(' '));
        else field.removeAttribute('aria-describedby');
      });
      const errorText = errors.join(' ');
      if (errorText && errorText !== previousErrors) {
        document.getElementById('alhc-announcement').textContent = errorText;
        firstInvalid?.focus();
      }
      previousErrors = errorText;
    };
    new MutationObserver(enhanceErrors).observe(product, {subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['class']});
    enhanceErrors();
  });
  document.querySelectorAll('[data-alhc-variant-buttons]').forEach(group => {
    group.hidden = false;
    group.closest('[data-alhc-product]').querySelector('[data-alhc-variant]').hidden = true;
  });
  document.addEventListener('click', event => {
    const open = event.target.closest('[data-alhc-open]');
    if (open) {
      const dialog = document.getElementById(open.dataset.alhcOpen);
      if (!dialog) return;
      event.preventDefault();
      const previous = open.closest('dialog');
      const origin = previous ? roots.get(previous) : open;
      // Suppress the queued close event when switching between drawers. Otherwise
      // it steals focus from the new modal and can leave Escape on a hidden button.
      if (previous) { roots.delete(previous); previous.close(); }
      roots.set(dialog, origin);
      dialog.showModal();
      (dialog.querySelector('input[type=search]') || dialog.querySelector('[data-alhc-close]'))?.focus();
    }
    const close = event.target.closest('[data-alhc-close]');
    if (close) close.closest('dialog')?.close();
    const thumbnail = event.target.closest('[data-alhc-thumbnail]');
    const variantButton = event.target.closest('[data-alhc-pick-variant]');
    if (variantButton) {
      const select = variantButton.closest('[data-alhc-product]').querySelector('[data-alhc-variant]');
      select.value = variantButton.dataset.alhcPickVariant;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (thumbnail) { event.preventDefault(); showMedia(thumbnail.closest('[data-alhc-product]'), thumbnail.dataset.alhcThumbnail); }
    const quantity = event.target.closest('[data-alhc-qty]');
    if (quantity) {
      const input = quantity.parentElement.querySelector('input');
      Number(quantity.dataset.alhcQty) > 0 ? input.stepUp() : input.stepDown();
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    const cartQuantity = event.target.closest('[data-alhc-cart-qty]');
    if (cartQuantity && !busy) {
      const line = cartQuantity.closest('[data-alhc-line]');
      const input = line.querySelector('input');
      Number(cartQuantity.dataset.alhcCartQty) > 0 ? input.stepUp() : input.stepDown();
      if (input.checkValidity()) updateLine(line, Number(input.value));
    }
    const remove = event.target.closest('[data-alhc-remove]');
    if (remove) { event.preventDefault(); if (!busy) updateLine(remove.closest('[data-alhc-line]'), 0); }
  });
  document.querySelectorAll('dialog.drawer').forEach(dialog => {
    dialog.addEventListener('close', () => { const origin = roots.get(dialog); roots.delete(dialog); if (origin?.isConnected && origin.getClientRects().length) origin.focus(); });
    dialog.addEventListener('click', event => { if (event.target === dialog && event.clientX < dialog.getBoundingClientRect().left) dialog.close(); });
  });
  function showMedia(root, id) {
    if (!id || !root.querySelector(`[data-alhc-media="${CSS.escape(id)}"]`)) return;
    root.querySelectorAll('[data-alhc-media]').forEach(media => {
      media.hidden = media.dataset.alhcMedia !== id;
      if (media.hidden) media.querySelectorAll('video').forEach(video => video.pause());
    });
    root.querySelectorAll('[data-alhc-thumbnail]').forEach(link => link.setAttribute('aria-current', String(link.dataset.alhcThumbnail === id)));
  }
  document.addEventListener('change', event => {
    if (event.target.matches('[data-alhc-variant]')) {
      const option = event.target.selectedOptions[0];
      const root = event.target.closest('[data-alhc-product]');
      root.querySelector('[data-alhc-current-price]').textContent = option.dataset.price;
      const compare = root.querySelector('[data-alhc-compare-price]');
      compare.hidden = !option.dataset.compare;
      compare.textContent = option.dataset.compare || '';
      root.querySelectorAll('[data-alhc-pick-variant]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.alhcPickVariant === option.value)));
      const button = root.querySelector('[data-alhc-add]');
      button.disabled = option.dataset.available !== 'true';
      button.textContent = button.disabled ? button.dataset.unavailableText : button.dataset.addText;
      showMedia(root, option.dataset.media);
      const url = new URL(location.href); url.searchParams.set('variant', option.value); history.replaceState(null, '', url);
      const input = root.querySelector('input[name=quantity]');
      input.min = option.dataset.min || '1'; input.step = option.dataset.step || '1';
      option.dataset.max ? input.max = option.dataset.max : input.removeAttribute('max');
      input.value = input.min;
      document.getElementById('alhc-announcement').textContent = option.textContent;
    }
    if (event.target.matches('[data-alhc-cart-input]') && !busy && event.target.checkValidity()) updateLine(event.target.closest('[data-alhc-line]'), Number(event.target.value));
  });
  async function updateLine(line, quantity) {
    if (busy) return;
    const root = line.closest('[data-alhc-cart]');
    const error = root.querySelector('[data-alhc-cart-error]');
    const controls = [...root.querySelectorAll('button,input,textarea')];
    const previous = controls.map(control => control.disabled);
    const note = root.querySelector('[name=note]').value;
    busy = true; error.textContent = ''; root.setAttribute('aria-busy', 'true');
    controls.forEach(control => control.disabled = true);
    document.getElementById('alhc-announcement').textContent = root.dataset.saving;
    try {
      const response = await fetch(root.dataset.updateUrl, {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({updates:{[line.dataset.alhcLine]:quantity},note})});
      const result = await response.json();
      if (!response.ok || result.errors) throw new Error(typeof result.description === 'string' ? result.description : root.dataset.error);
      location.reload();
    } catch (failure) {
      error.textContent = failure.message === 'Failed to fetch' ? root.dataset.error : failure.message;
      error.tabIndex = -1; error.focus();
      controls.forEach((control,index) => control.disabled = previous[index]);
      root.removeAttribute('aria-busy'); busy = false;
    }
  }
})();
